
// ... existing code ...

interface WhyChooseUsSectionProps {
  onOpenConsultationModal: () => void;
}

export default function WhyChooseUsSection({ onOpenConsultationModal }: WhyChooseUsSectionProps) {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Pourquoi choisir notre expertise comptable ?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Une solution d'externalisation pensée par et pour les experts-comptables français, 
            avec des garanties uniques sur le marché.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          <div className="bg-white rounded-xl p-8 shadow-sm hover:shadow-lg transition-shadow">
            <div className="w-16 h-16 flex items-center justify-center bg-blue-100 rounded-lg mb-6">
              <i className="ri-shield-check-line text-2xl text-blue-600"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-4">Expertise 100% française</h3>
            <p className="text-gray-600">
              Nos équipes maîtrisent parfaitement la réglementation comptable et fiscale française. 
              Experts-comptables diplômés et inscrits à l'ordre.
            </p>
          </div>

          <div className="bg-white rounded-xl p-8 shadow-sm hover:shadow-lg transition-shadow">
            <div className="w-16 h-16 flex items-center justify-center bg-green-100 rounded-lg mb-6">
              <i className="ri-time-line text-2xl text-green-600"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-4">Délais garantis</h3>
            <p className="text-gray-600">
              Respect strict des échéances fiscales et sociales. Engagement contractuel 
              sur les délais avec pénalités en cas de retard.
            </p>
          </div>

          <div className="bg-white rounded-xl p-8 shadow-sm hover:shadow-lg transition-shadow">
            <div className="w-16 h-16 flex items-center justify-center bg-purple-100 rounded-lg mb-6">
              <i className="ri-money-euro-circle-line text-2xl text-purple-600"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-4">Économies substantielles</h3>
            <p className="text-gray-600">
              Jusqu'à 60% d'économies sur vos coûts de production comptable, 
              sans compromis sur la qualité du service.
            </p>
          </div>

          <div className="bg-white rounded-xl p-8 shadow-sm hover:shadow-lg transition-shadow">
            <div className="w-16 h-16 flex items-center justify-center bg-orange-100 rounded-lg mb-6">
              <i className="ri-secure-payment-line text-2xl text-orange-600"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-4">Sécurité maximale</h3>
            <p className="text-gray-600">
              Hébergement des données en France, certification ISO 27001, 
              accords de confidentialité renforcés et assurance responsabilité civile.
            </p>
          </div>

          <div className="bg-white rounded-xl p-8 shadow-sm hover:shadow-lg transition-shadow">
            <div className="w-16 h-16 flex items-center justify-center bg-red-100 rounded-lg mb-6">
              <i className="ri-settings-3-line text-2xl text-red-600"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-4">Technologies de pointe</h3>
            <p className="text-gray-600">
              Outils de collaboration avancés, automatisation des processus, 
              intégration avec tous les logiciels comptables français.
            </p>
          </div>

          <div className="bg-white rounded-xl p-8 shadow-sm hover:shadow-lg transition-shadow">
            <div className="w-16 h-16 flex items-center justify-center bg-indigo-100 rounded-lg mb-6">
              <i className="ri-customer-service-line text-2xl text-indigo-600"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-4">Service personnalisé</h3>
            <p className="text-gray-600">
              Chaque cabinet bénéficie d'un interlocuteur dédié et d'un service 
              adapté à ses spécificités et contraintes métier.
            </p>
          </div>
        </div>

        <div className="text-center">
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-200">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Prêt à transformer votre cabinet ?
            </h3>
            <p className="text-lg text-gray-700 mb-6 max-w-2xl mx-auto">
              Découvrez comment notre solution d'externalisation peut vous aider à retrouver 
              du temps pour développer votre activité conseil et fidéliser vos clients.
            </p>
            <button 
              onClick={onOpenConsultationModal}
              className="bg-gray-200 text-black px-8 py-4 rounded-lg font-semibold text-lg hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              Planifier un entretien gratuit
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}